export default {
  init() {
    var navigation = $('.navigation--header');
    var search = $('.search-form');
    var navigationButton = $('.button--nav');
    var searchButton = $('.button--search');
    var languageSelectorButton = $('.button--language-selector');
    var navigationOpen = $('.button--nav__open', navigationButton);
    var navigationClose = $('.button--nav__close', navigationButton);
    var searchOpen = $('.button--search__open', searchButton);
    var searchClose = $('.button--search__close', searchButton);
    var navigationOpenClass = 'modal--open';
    var searchOpenClass = 'modal--open';
    var body = $('body');
    var bodyLockedClass = 'body--locked';

    function closeNavigation () {
      if (!navigation.hasClass(navigationOpenClass)) return;

      navigation.removeClass(navigationOpenClass);
      navigationClose.attr('aria-hidden', true);
      searchButton.attr('aria-hidden', false);
      navigationOpen.attr('aria-hidden', false);
      languageSelectorButton.attr('aria-hidden', false);
      body.removeClass(bodyLockedClass);
    }

    function openNavigation () {
      navigation.addClass(navigationOpenClass);
      navigationClose.attr('aria-hidden', false);
      searchButton.attr('aria-hidden', true);
      navigationOpen.attr('aria-hidden', true);
      languageSelectorButton.attr('aria-hidden', true);
      body.addClass(bodyLockedClass);
    }

    function closeSearch () {
      if (!search.hasClass(searchOpenClass)) return;
  
      search.removeClass(searchOpenClass);
      searchClose.attr('aria-hidden', true);
      navigationButton.attr('aria-hidden', false);
      searchOpen.attr('aria-hidden', false);
      languageSelectorButton.attr('aria-hidden', false);
      body.removeClass(bodyLockedClass);
      $('form input[type="text"]', search).blur();
      $('.is-ajax-search-result').hide();
    }

    function openSearch () {
      search.addClass(searchOpenClass);
      searchClose.attr('aria-hidden', false);
      navigationButton.attr('aria-hidden', true);
      searchOpen.attr('aria-hidden', true);
      languageSelectorButton.attr('aria-hidden', true);
      body.addClass(bodyLockedClass);
      $('form input[type="text"]', search).focus().trigger('click');
    }

    function toggleNavbar () {
      var navbar = $('.navbar');
      var navbarHiddenClass = 'navbar--hidden';
      var lastScrollPosition = 0;

      $(document).on('scroll', function () {
        var scrollPosition = $(this).scrollTop();

        scrollPosition < lastScrollPosition || scrollPosition <= 0 ? navbar.removeClass(navbarHiddenClass) : navbar.addClass(navbarHiddenClass);
        
        lastScrollPosition = scrollPosition;
      });
    }

    navigationButton.on('click', function () {
      navigation.hasClass(navigationOpenClass) ? closeNavigation() : openNavigation();
    });

    searchButton.on('click', function () {
      search.hasClass(searchOpenClass) ? closeSearch() : openSearch();
    });

    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeNavigation();
        closeSearch();
      }
    });

    $(document).on('click', function (e) {
      var target = $(e.target);
      
      if (target.closest(navigation).length === 0 && target.closest(navigationButton).length === 0) {
        closeNavigation();
      }
      
      if (target.closest(search).length === 0 && target.closest(searchButton).length === 0 && !target.is($('form input[type="text"]', search))) {
        closeSearch();
      }
    });

    toggleNavbar();
  },
};
